module.exports = __webpack_public_path__ + "img/login-phone-verify.15a4959d.svg";